<div>
    <div style="margin-left: 80%; margin-bottom: 2%">
     
<button *ngIf="updateStatus" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
color="primary" (click)="saveSubscriptionBarcodesDataEntry()">
save
</button>



      
  <!-- <button [useExistingCss]="true" class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button
            color="primary" printTitle="Label" printSectionId="print-section" ngxPrint>
            print
        </button> -->

        <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary" (click)="printPage()">
            Print
        </button>

           
        <button mat-dialog-close class="btn noPrint">Close</button>
    </div>
  
    <div class="container mt-3" id="print-section">
                        <!-- <div class="col" *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;">
                             <label>
                                 <input type="checkbox" [(ngModel)]="masterSelected" (change)="checkUncheckAll()"> All
                           </label>
                       </div>  -->
            
        <div class="row wrapper" *ngFor="let item of showFilteredData ? filteredList : combinedList" >
            <ng-container *ngIf="item.prati != 0">
            <div class="card" style="page-break-inside: avoid;" *ngIf="item.prati != 0">
                <div class="firstrow">
                    
                    <!-- <div class="col noPrint"  *ngIf="!updateStatus" style="border-width: 0px 1px 1px 1px;"> -->
                        <!-- <label>
                            <input type="checkbox" [(ngModel)]="item.isSelected" (change)="isAllSelected()"> {{ item.value }}
                          </label> -->
                        <!-- <input type="checkbox" [(ngModel)]="data.selected" (change)="isAllSelected()"> -->
                    <!-- </div> -->
                  
                    <div class="left">
                        <img src="../../../assets/img/brand/red.png" alt="" width="100">
                    </div>
                    <div class="right">
                       
                        <span>हिंदुस्थान प्रकाशन संस्था</span>
                        <span>116-119, शिल्पीन सेंटर, पहिला मजला, गं. द. आंबेकर मार्ग,</span>
                        <span> , वडाळा, मुंबई - 400 031 दूरध्वनीः 9967570531</span>
                      
                    </div>
                </div>
                <div class="line"></div>
                <div class="maincontent">
                    <div class="vitaran "><span class="">वितरण माध्यम - {{ item['dis_mode'] }} - {{ item['dis_sub_mode'] }}</span>
                        <span class="">अंक दिनांक : {{isuuedate | date:'dd/MM/yyyy' }}</span>
                    </div>
                    <div class="prati">
                        <div></div>
                        <div class="right"><span>प्रति,</span>
                            <span class="date" style="margin-right: -209px;margin-left: 209px;">वितरण दिनांक : {{ item["dispatch_date"] | date:'dd/MM/yyyy' }}</span>
                        </div>
                    </div>
                    <div class="main">
                        <div class="pratisankhya">
                            <span style="font-size: 16px;" class="f-w-600">प्रति - </span>
                            <span class="fs-16" style="font-weight: 800;font-size: 16px">{{ item.prati }}</span>
                        </div>
                        <div class="name">
                            <span  style="font-weight: 600;">{{ item["issueSellerName"] }}</span>
                            <span class="fs-16">{{ item["full_add"] }} </span>
                            <!-- <span class="fs-16">{{ item["dis_dist"] }} - {{ item["dis_pin"] }} <br> {{
                                item["dis_state"] }}</span> -->
                            <span class="fs-16">{{item["taluka"] }},{{item["district"] }} - {{item["pincode"] }},
                                {{item["state"] }},{{item["country"] }}. 
                            </span> 
                            <!-- <span class="fs-16">{{item["state"] }} - {{item["country"] }} </span> -->
                            <span class="fs-16">मोबाईल नं :  {{item["mob_no"] }} </span>
                        </div>
                    </div>
                </div>
            </div>
            </ng-container>
        </div>
       
    </div>
</div>